import {
  orderFilterValuesLabels,
  orderTypeLocale,
} from '@epicuro-next/constants/features/localization';
import { OrderFilterId } from '@epicuro-next/models/order-book';
import { OrderType } from 'graphql-api/baskets-api-interfaces';

import { getDateValue } from '../../get-value/get-value';

export type FiltersWithNames = Extract<
  OrderFilterId,
  OrderFilterId.Account | OrderFilterId.Address | OrderFilterId.Brand
>;

export type FiltersNamesMap = {
  [value in FiltersWithNames]?: Record<string, string>;
};

export const getName = (
  entities: Record<string, string> = {},
  key: string,
): string => entities[key] ?? key;

export const getValueToDisplayNameMappers = (
  filtersNamesMap: FiltersNamesMap,
  locale: string,
) => ({
  [OrderFilterId.Account]: getName.bind(
    null,
    filtersNamesMap[OrderFilterId.Account],
  ),
  [OrderFilterId.Address]: getName.bind(
    null,
    filtersNamesMap[OrderFilterId.Address],
  ),
  [OrderFilterId.Brand]: getName.bind(
    null,
    filtersNamesMap[OrderFilterId.Brand],
  ),
  [OrderFilterId.Month]: (value: string) =>
    getDateValue(value, locale, 'MMM yy'),
  [OrderFilterId.Year]: (value: string) => getDateValue(value, locale, 'yyyy'),
  [OrderFilterId.Noos]: getName.bind(null, {
    True: orderFilterValuesLabels.noosTypeTrue,
    False: orderFilterValuesLabels.noosTypeFalse,
  }),
  [OrderFilterId.IsDelivered]: getName.bind(null, {
    false: orderFilterValuesLabels.orderStatusInbound,
    true: orderFilterValuesLabels.orderStatusHistory,
  }),
  [OrderFilterId.OrderType]: getName.bind(null, {
    1: orderTypeLocale[OrderType.Now],
    2: orderTypeLocale[OrderType.Future],
  }),
  [OrderFilterId.Gender]: getName.bind(null, {
    Male: orderFilterValuesLabels.genderMale,
    Female: orderFilterValuesLabels.genderFemale,
    Neutral: orderFilterValuesLabels.genderNeutral,
  }),
});
